// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  LocationMode,
} from "./types";


export default __t.row({
  twinId: __t.string().primaryKey().name("twin_id"),
  get locationMode() {
    return LocationMode.name("location_mode");
  },
  geoLocationLatitude: __t.option(__t.f64()).name("geo_location_latitude"),
  geoLocationLongitude: __t.option(__t.f64()).name("geo_location_longitude"),
  geoLocationElevation: __t.option(__t.f64()).name("geo_location_elevation"),
  orientationYaw: __t.option(__t.f32()).name("orientation_yaw"),
  orientationPitch: __t.option(__t.f32()).name("orientation_pitch"),
  orientationRoll: __t.option(__t.f32()).name("orientation_roll"),
  streamName: __t.option(__t.string()).name("stream_name"),
  meshSection: __t.option(__t.string()).name("mesh_section"),
});
